import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE} from "../Apis/functions";

export const Company = {
    acronym: '',
    address: '',
    createdAt: null,
    introduction: '',
    ip: null,
    id: null,
    name: '',
    image: null,
    statusId: null,
    updatedAt: null,
    latitud: DEFAULT_LATITUDE,
    longitud: DEFAULT_LONGITUDE,
    mission: '',
    vision: '',

    toUpdate: function () {
        return {
            acronym: this.acronym,
            address: this.address,
            introduction: this.introduction !== '' ? this.introduction : null,
            id: this.id,
            name: this.name,
            statusId: this.statusId,
            latitud: this.latitud,
            longitud: this.longitud,
            mission: this.mission !== '' ? this.mission : null,
            vision: this.vision !== '' ? this.vision : null,
        };
    },

    isValid: function () {
        return this.acronym !== "" && this.address !== "" && this.introduction !== "" && this.name !== "" && this.mission !== "" && this.vision !== ""
    }
};


